"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.wheelAnalysis = exports.view = exports.vehicle = exports.task = exports.part = exports.inspection = exports.image = exports.damage = exports.damageArea = void 0;
exports.damageArea = __importStar(require("./damageAreas"));
exports.damage = __importStar(require("./damages"));
exports.image = __importStar(require("./images"));
exports.inspection = __importStar(require("./inspections"));
exports.part = __importStar(require("./parts"));
exports.task = __importStar(require("./tasks"));
exports.vehicle = __importStar(require("./vehicles"));
exports.view = __importStar(require("./views"));
exports.wheelAnalysis = __importStar(require("./wheelAnalysis"));
//# sourceMappingURL=entities.js.map